import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export let useMainForm = create(immer((set, get) => ({})));
